import { render } from "./IsoInChangedTest.vue?vue&type=template&id=219570b4"
import script from "./IsoInChangedTest.vue?vue&type=script&lang=js"
export * from "./IsoInChangedTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__